export const GET_DYNAMIC_COLUMN_REQUEST = "GET_DYNAMIC_COLUMN_REQUEST";
export const GET_DYNAMIC_COLUMN_SUCCESS = "GET_DYNAMIC_COLUMN_SUCCESS";
export const GET_DYNAMIC_COLUMN_FAILURE = "GET_DYNAMIC_COLUMN_FAILURE";

export const CREATE_DYNAMIC_COLUMN_REQUEST = "CREATE_DYNAMIC_COLUMN_REQUEST";
export const CREATE_DYNAMIC_COLUMN_SUCCESS = "CREATE_DYNAMIC_COLUMN_SUCCESS";
export const CREATE_DYNAMIC_COLUMN_FAILURE = "CREATE_DYNAMIC_COLUMN_FAILURE";
